import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ResetDeviceService } from '../../../Model/ResetDevice/reset-device.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-device-reset',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './device-reset.component.html',
  styleUrl: './device-reset.component.scss'
})
export class DeviceResetComponent {
  public User: any = null;
  EmployeeCode: string = '';
  EmployeeType: string = 'Front';
  IMEINo: string = '';
  EmpName: string = '';
  IMEINoLoad: any[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(private modalService: NgbModal,
    private resetDevice: ResetDeviceService,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {}
  
  onSelectionChange(type: string, event: any) {
    if (type == 'EmployeeType') {
      this.EmployeeType = event.target.value;
      this.IMEINoLoad = [];
    }
  }
  Search() {
    if (this.EmployeeCode == '') {
      this.toast.show({ message: 'Please Enter Employee Code!', type: toastTypeEnum.warning });
      return;
    }
    else {
      this.ComboLoad('IMEINo', this.EmployeeCode);
    }
  }
  ComboLoad(Combotype: String, id = '') {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'EmpType': this.EmployeeType,
      'EmpCode': id,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'IMEINo') {
          this.IMEINoLoad = response.ComboLoad;
          if (this.IMEINoLoad.length === 0) {
            this.toast.show({ message: 'Employee not found!', type: toastTypeEnum.warning });
            this.isDisabled = false;
            return
          }
          this.IMEINo = this.IMEINoLoad[0].IMEINumber;
          this.EmpName = this.IMEINoLoad[0].FullName;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  async Reset() {
    await this.common.getPageRights();
    if (this.IMEINoLoad.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Reset?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.update();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
    });
  }
  update() {
    this.isDisabled = true;
    const IMEIData = {
      EmpCode: this.EmployeeCode,
      Reset: true,
    };
    this.resetDevice.Ess_IMEINumberUpdate(IMEIData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.ComboLoad('IMEINo', this.EmployeeCode);
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  onKeyPress(event: any) {
    this.IMEINoLoad = [];
  }
}

